<template>
    <div class="broadcast-box">
        <div class="broadcast-box-bg">
            <a href="#add"><el-button>立即咨询</el-button></a>
            <div class="broadcast-box-common broadcast-box-infor">
                <h3>专业介绍</h3>
                <p>播音与主持艺术在我国是一个新兴专业，随着文化产业的飞速发展，播音主持职业将成为未来就业领域的热点和亮点。全国有播音主持专业院校超过一百三十所，以中国传媒大学、中国传媒大学南广学院，浙江传媒学院、山西传媒学院、上海戏剧学院为代表的全国播音主持专业院校每年培养数千播音主持人才。<br>本专业面向广播影视媒体及相关机构，培养具备中国播音学、新闻传播学、中国语言文学哲学美学、艺术学等多学科知识与能力，从事广播电视普通话新闻播音主持及新闻报道专题播音主持、文艺节目主持、体育评论解说、双语播音主持、影视配音及演播，以及播音主持教学与研究工作的复合型语言传播精英人才。</p>
            </div>
        </div> 
        <div class="broadcast-box-work broadcast-box-common">
            <h3>就业方向</h3>
            <el-row type="flex" class="broadcast-box-work-list">
                <el-col v-for="(item,index) in workList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="broadcast-box-tiao broadcast-box-common broadcast-box-common1">
            <h3>报考条件</h3>
            <h4>发音器官无疾病，无色盲，无夜盲，五官端正，身体健康的学生</h4>
            <el-row class="broadcast-box-tiao-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in tiaoList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="broadcast-box-test broadcast-box-common">
            <h3>考试内容</h3>
            <el-row class="broadcast-box-test-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in testList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="broadcast-box-subject broadcast-box-common broadcast-box-common1">
            <h3>学习科目</h3>
            <h4>普通话语音、播音发声、播音创作等基本理论和基础知识</h4>
            <el-row class="broadcast-box-subject-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in subjectList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="broadcast-box-tips broadcast-box-common broadcast-box-common1">
            <h3>考试流程</h3>
            <el-row class="broadcast-box-tips-content" type="flex" justify="space-between">
                <el-col class="broadcast-box-tips-item1">
                    <h4>基本条件</h4>
                    <div>1.发音器官无疾病，普通话，形体、形象、气质、身高 <br> 2.新闻播读 (现场抽题，限2分钟) <br> 3.文学作品朗读（中外文学作品片段，字数300-400字，现场抽题限2分钟）</div>
                </el-col>
                <el-col class="broadcast-box-tips-item2">
                    <h4>即兴评述</h4>
                    <div>现场抽题，准备5分钟，不得写成提 纲或文稿，限3分钟</div>
                </el-col>
                <el-col class="broadcast-box-tips-item3">
                    <h4>才艺展示</h4>
                    <div>限唱歌、舞蹈、曲艺、演奏类（除 钢琴外，其它器乐自备），限3分钟</div>
                </el-col>
                <el-col class="broadcast-box-tips-item4">
                    <h4>自备文学作品朗读</h4>
                    <div>限2分钟，体裁不限</div>
                </el-col>
            </el-row>
        </div>
        <div class="broadcast-box-school broadcast-box-common broadcast-box-common1">
            <h3>推荐院校</h3>
            <el-row class="broadcast-box-school-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in schoolList" :key="index">
                    <img :src="item.src" alt="">
                    <span>{{item.desc}}</span>
                </el-col>
            </el-row>
        </div>
        <div class="broadcast-box-order" id="add">
            <div class="broadcast-box-order-content broadcast-box-common broadcast-box-common1">
                <h3>提交咨询表</h3>
                <h4>填写信息后，可以查询更多艺考信息</h4>
                <el-row>
                    <el-form :inline="true" :model="formInline" class="order-form-inline" :rules="rules" ref="formInline">
                        <el-form-item label="姓名：" prop="username">
                            <el-input v-model="formInline.username" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="电话：" prop="phone">
                            <el-input v-model="formInline.phone" placeholder="请输入电话"></el-input>
                        </el-form-item>
                        <el-form-item label="专业：" prop="major">
                            <el-input v-model="formInline.major" placeholder="请输入专业"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="addSubscribeHandler" v-click-with-auth-login>提交</el-button>
                        </el-form-item>
                        </el-form>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import { addSubscribe } from '@/api/user'
export default {
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入姓名"));
            } else {
                callback();
            }
        };
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入电话"));
                } else {
                if ((/^1[34578]\d{9}$/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的电话"));
                }
            }
        };
        const validateMajor = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入专业"));
            } else {
                callback();
            }
        };
        return {
            workList:[
                {src:require('../../assets/images/broadcast-work-icon1.png'),desc:'电视台主持人'},
                {src:require('../../assets/images/broadcast-work-icon2.png'),desc:'广告配音'},
                {src:require('../../assets/images/broadcast-work-icon3.png'),desc:'影视传媒'},
                {src:require('../../assets/images/broadcast-work-icon4.png'),desc:'文化团体'},
                {src:require('../../assets/images/broadcast-work-icon5.png'),desc:'大型企事业单位'},
                {src:require('../../assets/images/broadcast-work-icon6.png'),desc:'影视配音'},
                {src:require('../../assets/images/broadcast-work-icon7.png'),desc:'IT产业的新闻播音'},
                {src:require('../../assets/images/broadcast-work-icon8.png'),desc:'节目主持'},
                {src:require('../../assets/images/broadcast-work-icon9.png'),desc:'各类庆典主持'},
                {src:require('../../assets/images/broadcast-work-icon10.png'),desc:'网络媒体'},
                {src:require('../../assets/images/broadcast-work-icon11.png'),desc:'宣传'},
                {src:require('../../assets/images/broadcast-work-icon12.png'),desc:'策划'},
            ],
            tiaoList:[
                {src:require('../../assets/images/broadcast-tiao-icon1.png'),desc:'女生不低于1.6米，男生不低于1.7米'},
                {src:require('../../assets/images/broadcast-tiao-icon2.png'),desc:'相貌端正，普通话标准'},
                {src:require('../../assets/images/broadcast-tiao-icon3.png'),desc:'口齿清晰，听力正常'},
                {src:require('../../assets/images/broadcast-tiao-icon4.png'),desc:'身材匀称，形象气质俱佳'},
                {src:require('../../assets/images/broadcast-tiao-icon5.png'),desc:'较好的语言感受能力和表达能力'},
                {src:require('../../assets/images/broadcast-tiao-icon6.png'),desc:'敏锐的思维能力和应变能力'},
            ],
            testList:[
                {src:require('../../assets/images/broadcast-test-icon1.png'),desc:'自我介绍'},
                {src:require('../../assets/images/broadcast-test-icon2.png'),desc:'指定、自备稿件朗诵'},
                {src:require('../../assets/images/broadcast-test-icon3.png'),desc:'主持小栏目'},
                {src:require('../../assets/images/broadcast-test-icon4.png'),desc:'即兴评述'},
                {src:require('../../assets/images/broadcast-test-icon5.png'),desc:'才艺展示'},
            ],
            subjectList:[
                {src:require('../../assets/images/broadcast-subject-icon1.png'),desc:'自我介绍技巧'},
                {src:require('../../assets/images/broadcast-subject-icon2.png'),desc:'模拟主持'},
                {src:require('../../assets/images/broadcast-subject-icon3.png'),desc:'即兴评述'},
                {src:require('../../assets/images/broadcast-subject-icon4.png'),desc:'面试技巧'},
                {src:require('../../assets/images/broadcast-subject-icon5.png'),desc:'热点评述'},
                {src:require('../../assets/images/broadcast-subject-icon6.png'),desc:'诗歌朗诵'},
                {src:require('../../assets/images/broadcast-subject-icon7.png'),desc:'文学常识'},
                {src:require('../../assets/images/broadcast-subject-icon8.png'),desc:'自备稿件'},
            ],
            schoolList:[
                {src:require('../../assets/images/director-school-icon1.jpg'),desc:'中国传媒大学'},
                {src:require('../../assets/images/director-school-icon2.jpg'),desc:'浙江传媒学院'},
                {src:require('../../assets/images/performance-school-icon5.png'),desc:'武汉大学'},
                {src:require('../../assets/images/broadcast-school-icon1.png'),desc:'重庆大学'},
                {src:require('../../assets/images/broadcast-school-icon2.png'),desc:'广州大学'},
                {src:require('../../assets/images/director-school-icon6.jpg'),desc:'湖南大学'},
                {src:require('../../assets/images/broadcast-school-icon3.png'),desc:'南昌大学'},
                {src:require('../../assets/images/performance-school-icon6.png'),desc:'四川师范大学'},
                {src:require('../../assets/images/broadcast-school-icon4.png'),desc:'成都理工大学'},
                {src:require('../../assets/images/director-school-icon8.jpg'),desc:'四川大学'},
            ],
            formInline: {
                username: '',
                phone: '',
                major: '',
                type: '10'
            },
            rules: {
                username: [
                    { trigger: 'blur', validator: validateUsername },
                ],
                phone: [
                    { trigger: 'blur', validator: validatePhone },
                ],
                major: [
                    { trigger: 'blur', validator: validateMajor },
                ],
            }
        };
    },
    methods: {
        addSubscribeHandler() {
            let that = this;
            this.$refs.formInline.validate((valid) => {
                if(valid) {
                    addSubscribe(that.formInline).then(res => {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    })
                }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
$font-family: 'MicrosoftYaHei';
$width: 1200px;
$margin: 0 auto;
.broadcast-box-common {
    padding-top: 62px;
    box-sizing: border-box;
    h3 {
        font-size: 36px;
        font-family: $font-family;
        font-weight: 700;
        text-align: center;
        color: #332e2c;
        line-height: 47px;
        letter-spacing: 3.6px;
        margin: 0;
    }
}
.broadcast-box-common1 {
    >h4 {
        font-size: 18px;
        font-family: $font-family;
        font-weight: 400;
        text-align: center;
        color: rgba(255,255,255,0.60);
        line-height: 24px;
        margin: 27px 0 62px 0;
    }
}
.broadcast-box-bg {
    background: url('../../assets/images/broadcast-bg.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    height: 644px;
    button {
        width: 136px;
        height: 50px;
        background: rgba(255,255,255,0.20)!important;
        border: 1px solid #ffffff!important;
        border-radius: 8px;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        position: relative;
        left: calc(50% - 600px);
        top: 320px;
    }
    button:hover {
        background: rgba(255,255,255,0)!important;
    }
}
.broadcast-box-infor {
    width: $width;
    margin: $margin;
    height: 400px;
    background: rgba(255,255,255,0.90);
    border-radius: 20px;
    box-shadow: 0px 4px 20px 0px rgba(143,43,0,0.12), 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
    backdrop-filter: blur(4px);
    padding: 44px 58px;
    margin-top: 400px;
    p {
        font-size: 20px;
        font-family: $font-family;
        font-weight: 400;
        color: #2c3331;
        line-height: 38px;
        margin-top: 36px;
    }
}
.broadcast-box-work {
    padding-top: 235px;
    height: 886px;
    background: #f5f7fa;
    box-sizing: border-box;
    .broadcast-box-work-list {
        width: $width;
        margin: $margin;
        // align-content:space-between;
        // flex-flow: row wrap;
        flex-wrap: wrap;
        margin-top: 69px;
    }
    .el-col:not(:nth-child(6n)) {
        margin-right: 48px;
    }
    .el-col {
        width: 160px;
        text-align: center;
        h5 {
            margin-top: 20px;
            font-size: 20px;
            font-family: $font-family;
            font-weight: 400;
            text-align: center;
            color: #2c3331;
            line-height: 26px;
        }
    }
}
.broadcast-box-tiao {
    height: 784px;
    background: url('../../assets/images/broadcast-tiao-bg.jpg') no-repeat center;
    background-size: cover;
    position: relative;
    padding-top: 52px;
    h3 {
        color: #ffffff;
    }
    .broadcast-box-tiao-content {
        width: $width;
        margin: 0 auto;
        flex-wrap: wrap;
        margin-top: 4px;
        .el-col {
            width: 376px;
            position: relative;
            margin-bottom: 40px;
        }
        h5 {
            // padding: 0 30px;
            margin: 0;
            font-size: 18px;
            position: absolute;
            font-family: $font-family;
            font-weight: 400;
            text-align: center;
            color: #ffffff;
            line-height: 60px;
            text-align: center;
            height: 60px;
            background: rgba(0,44,109,0.60);
            border-radius: 0px 0px 20px 20px;
            bottom: 0;
            width: 100%;
        }
    }
}
.broadcast-box-test {
    background: url('../../assets/images/common-test.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    height: 480px;
    .broadcast-box-test-content {
        width: $width;
        margin: $margin;
        flex-wrap: wrap;
        margin-top: 62px;
        .el-col {
            width: 224px;
            h5 {
                font-size: 22px;
                font-family: $font-family;
                font-weight: 400;
                text-align: center;
                color: #332e2c;
                margin: 20px 0 0 0;
            }
        }
    }
}
.broadcast-box-subject {
    width: 100%;
    height: 627px;
    background: #096cf2;
    h3 {
        color: #fff;
    }
    .broadcast-box-subject-content {
        width: $width;
        margin: $margin;
        flex-wrap: wrap;
        .el-col {
            width: 25%;
            text-align: center;
            h5 {
                font-size: 20px;
                font-family: $font-family;
                font-weight: 400;
                text-align: center;
                color: #ffffff;
                line-height: 26px;
                margin: 20px 0 60px 0;
            }
        }
    }
}
.broadcast-box-tips {
    width: 100%;
    height: 543px;
    background: #ffff;
    .broadcast-box-tips-content {
        width: $width;
        margin: $margin;
        margin-top: 48px;
        .el-col {
            width: 280px;
            height: 314px;
            border-radius: 8px;
            padding: 24px 22px 24px 24px;
            box-sizing: border-box; 
            h4 {
                font-size: 28px;
                font-family: $font-family;
                font-weight: 700;
                color: #2c3331;
                margin: 0;
                margin-bottom: 2px;
                line-height: 37px;
            }
            div {
                margin-top: 26px;
                font-size: 18px;
                font-family: $font-family;
                font-weight: 400;
                color: #2c3331;
                line-height: 26px;
                position: relative;
                line-height: 28px;
            }
            span {
                display: inline-block;
                width: 71%;
                margin-left: 82px;
            }
            .broadcast-box-tips-count {
                width: 74px;
                height: 30px;
                background: #348aff;
                border-radius: 5px;
                font-size: 16px;
                font-family: $font-family;
                font-weight: 400;
                color: #ffffff;
                line-height: 30px;
                text-align: center;
                margin-right: 10px;
                position: absolute;
                top: 0;
                margin-left: 0;
                
            }
        }
        .broadcast-box-tips-item1 {
            background: #ecf4ff;
            border: 1px solid #b3d3ff;
        }
        .broadcast-box-tips-item2 {
            background: #fff4eb;
            border: 1px solid #ffdbbd;
        }
        .broadcast-box-tips-item3 {
            background: #f2f7e7;
            border: 1px solid #c4de89;
        }
        .broadcast-box-tips-item4 {
            background: #fff4f4;
            border: 1px solid #f1c9c7;
        }
    }
}
.broadcast-box-school {
    height: 443px;
    background: url('../../assets/images/director-school-bg.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    h3 {
        color: #fff;
    }
    .broadcast-box-school-content {
        width: $width;
        margin: $margin;
        flex-wrap: wrap;
        .el-col {
            padding: 16px;
            width: 220px;
            height: 88px;
            box-sizing: border-box;
            background: #ffffff;
            border-radius: 8px;
            margin-top: 48px;
            span {
                display: inline-block;
                font-size: 20px;
                font-family: $font-family;
                font-weight: 400;
                color: #2c3331;
                line-height: 26px;
                position: relative;
                top: -18px;
                left: 12px;
            }
        }
    }
}
.broadcast-box-order {
    background: url('../../assets/images/common-bg.png') no-repeat;
    background-size: cover;
    background-color: #096cf2;
    height: 359px;
    margin-bottom: -56px;
    h3 {
        color: #fff;
    }
    h4 {
        margin-bottom: 55px;
    }
    .broadcast-box-order-content {
        width: $width;
        margin: $margin;
        .order-form-inline {
            margin-top: 0;
        }
        span {
            display: inline-block;
        }
        img {
            position: absolute;
            top:0;
            left: 0;
        }
        .broadcast-box-order-title {
            font-size: 36px;
            font-family: 'zihun443hao';
            color: #ffffff;
        }
        .broadcast-box-order-desc {
            font-size: 18px;
            font-weight: 500;
            color: #ffffff;
            margin-left: 24px;
        }
    }
}
</style>